import { Component, OnInit } from '@angular/core';
import {BooKingservice} from "../booking.service";
import {FoEventsService} from "../../event/foevents.service";

@Component({
  selector: 'app-booking-deadline-payment',
  templateUrl: './booking-deadline-payment.component.html',
  styleUrls: ['./booking-deadline-payment.component.css']
})
export class BookingDeadlinePaymentComponent implements OnInit {
  deadlines :any;
  paidDeadlines :any;
  nthdeadlines :any;
  order :any;

  constructor(private bookingservice: BooKingservice, private eventservicce : FoEventsService ) {

  }

  initData() {
    this.deadlines = this.bookingservice.retrieve('deadlines');
    this.paidDeadlines = this.bookingservice.retrieve('paidDeadlines');
    this.nthdeadlines = this.bookingservice.retrieve('nthdeadlines');
    this.order = this.bookingservice.retrieve('order');

  }

  ngOnInit() {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let id = url.searchParams.get("id");
    let that = this;
    setTimeout(function () {
      that.initData();
    },1000)
  }

  valider() {
    this.bookingservice.store('deadlinePayment',true);
    this.eventservicce.paydeadline(this.deadlines[this.nthdeadlines-1]).then(res => {
      let payment =  res.payment;
      let form    =  document.createElement("form");
      form.method =  "POST";
      form.action =  payment.endpoint;
      Object.keys(payment.form).forEach(function (key) {
        let element = document.createElement("input");
        element.type = "hidden";
        element.value = payment.form[key];
        element.name = key;
        form.appendChild(element);
      });
       document.body.appendChild(form);
        form.submit()
      }
    )
  }

}
